// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// 🚨 CRITICAL: REPLACE ALL OF THESE VALUES with the EXACT configuration from your Firebase Project Settings.
const firebaseConfig = {
    apiKey: "AIzaSyBeF3SLgILgMgif1F7QMIzcUTO9BcOCZD8", // <-- MUST BE EXACT!
    authDomain: "hotel-test-project-16e2e.firebaseapp.com", 
    projectId: "hotel-test-project-16e2e", 
    storageBucket: "hotel-test-project-16e2e.firebasestorage.app", 
    messagingSenderId: "444449601356", 
    appId: "1:444449601356:web:64d4fa4fb27618528f41e9" 
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);